import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Avatar,
  Grid,
  Chip,
  Tooltip,
  Stack,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  RadioGroup,
  Radio,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";
import { green, grey } from "@mui/material/colors";
import { useParams } from "react-router-dom";
import P2PNavbar from "./P2PNavbar";
import {
  P2PWEBSERVICE,
  WEBSERVICE,
  decryptMessages,
  showToast,
} from "../../CoreDataService";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTheme, alpha } from "@mui/material/styles";
import p2pWebSocketService from "./p2pWebSocketService";
// import EditSquareIcon from '@mui/icons-material/EditSquare';
import EditIcon from "@mui/icons-material/Edit";
import { useChat } from "../../Services/ChatService";
import axios from "axios";
import { use } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import ModalContent from "../../Common/Modal";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import CloseIcon from "@mui/icons-material/Close";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

const P2PPublicProfile = () => {
  const {
    message,
    onlineUsers,
    onlineBroker,
    p2pmessage,
    p2pmessageCustomer,
    p2pmessageCustomerAppeal,
    makeUserOnline,
    sendMessageToUser,
  } = useChat(); // Access state and methods

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange", // Ensures real-time validation updates
    defaultValues: {
      accountHolder: "",
      ibanNumber: "",
      bankName: "",
      accountType: "",
      bankAddress: "",
      codeType: "",
      additionalCode: "",
    },
  });
  const themecolor = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);

  const theme = useTheme();
  const { uuid } = useParams();
  const [holdingInUsd, setHoldingInUsd] = useState(null);
  const [allBuyAds, setAllBuyAds] = useState([]);
  const [allSellAds, setAllSellAds] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [poitiveFeedPercent, setPoitiveFeedPercent] = useState(0);
  const [bankTransferPaymentMethodList, setBankTransferPaymentMethodList] =
    useState([]);
  const [walletServicePaymentMethodList, setWalletServicePaymentMethodList] =
    useState([]);
  const navigate = useNavigate();

  const [orderType, setOrderType] = useState("BUY");
  const [amount, setAmount] = useState("");
  const [currency, setCurrency] = useState("All Currencies");
  const [paymentMethod, setPaymentMethod] = useState("All Payment Methods");
  const [region, setRegion] = useState("All Regions");
  const [regionList, setRegionList] = useState([]);

  const [sortOrder, setSortOrder] = useState("0");
  const [selectedFiatCurrency, setSelectedFiatCurrency] = useState("USDT");

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const websocketRef = useRef(null);
  const [ads, setAds] = useState([]);
  const [buyOrders, setBuyOrders] = useState([]);

  const [allCurrencies, setAllCurrencies] = useState([]);
  const [visibleCurrencies, setVisibleCurrencies] = useState(
    allCurrencies.slice(0, 6)
  );
  const [hiddenCurrencies, setHiddenCurrencies] = useState(
    allCurrencies.slice(6)
  );
  const [allFiatList, setAllFiatList] = useState([]);
  const [recordCount, setRecordCount] = useState(null);
  const [completionRate, setCompletionRate] = useState(null);
  const [paymentTimeLimit, setPaymentTimeLimit] = useState(null);
  const [minOrderLimit, setMinOrderLimit] = useState(null);
  const [maxOrderLimit, setMaxOrderLimit] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [price, setPrice] = useState(null);
  const [fiat, setFiat] = useState("");
  const [crypto, setCrypto] = useState("");
  const [paymentProviderName, setPaymentProviderName] = useState([]);
  const [availableAmount, setAvailableAmount] = useState(null);
  const [profileName, setProfileName] = useState("");
  const [adId, setAdId] = useState(null);
  const [counterPartyUuid, setCounterPartyUuid] = useState("");
  const [orderId, setOrderId] = useState(null);
  const [sellAmount, setSellAmount] = useState(null);
  const [onlineStatus, setOnlineStatus] = useState(null);
  const [profilePic, setProfilePic] = useState("");
  const [profileImageLink, setProfileImageLink] = useState("");
  const [firstLetter, setFirstLetter] = useState("");
  const [
    currentSelectedBankPaymentMethod,
    setCurrentSelectedBankPaymentMethod,
  ] = useState([]);
  const [selectedBankPaymentMethod, setSelectedBankPaymentMethod] = useState(
    []
  );
  const [
    currentSelectedWalletPaymentMethod,
    setCurrentSelectedWalletPaymentMethod,
  ] = useState([]);
  const [selectedWalletPaymentMethod, setSelectedWalletPaymentMethod] =
    useState([]);
  const [buyDialogOpen, setBuyDialogOpen] = useState(false);
  const [sellDialogOpen, setSellDialogOpen] = useState(false);
  const [walletAvailableBalance, setWalletAvailableBalance] = useState(0);
  const [modalPrice, setModalPrice] = useState(null);
  const [modalRemainingAmount, setModalRemainingAmount] = useState(null);
  const [payAmount, setPayAmount] = useState(null);
  const [receiveAmount, setReceiveAmount] = useState(null);
  const [paymentEditModal, setPaymentEditModal] = useState(false);
  const [formValues, setFormValues] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [pmDetailsId, setPmDetailsId] = useState(null);
  const [editPaymentMethod, setEditPaymentMethod] = useState("");

  const [accountHolderNameEdit, setAccountHolderNameEdit] = useState("");
  const [paymentProviderNameEdit, setPaymentProviderNameEdit] = useState("");
  const [phoneNumberEdit, setPhoneNumberEdit] = useState("");
  const [walletIdEdit, setWalletIdEdit] = useState("");
  const [emailIdEdit, setEmailIdEdit] = useState("");

  const [accountNumberEdit, setAccountNumberEdit] = useState("");
  const [accountTypeEdit, setAccountTypeEdit] = useState("");
  const [identificationTypeEdit, setIdentificationTypeEdit] = useState("");
  const [routingNumberEdit, setRoutingNumberEdit] = useState("");
  const [bankNameEdit, setBankNameEdit] = useState("");
  const [bankAddressEdit, setBankAddressEdit] = useState("");

  const [paymentMethodOptions, setPaymentMethodOptions] = useState([]);
  const [accountTypeOptions, setAccountTypeOptions] = useState([]);
  const [bankIdentificationTypeOptions, setBankIdentificationTypeOptions] =
    useState([]);
  const [selectedAccountType, setSelectedAccountType] = useState("");
  const [selectedCodeType, setSelectedCodeType] = useState("");
  const [adsloading, setAdsloading] = useState("");
  const [blockModalOpen, setBlockModalOpen] = useState(false);

  const [allBlockReason, setAllBlockReason] = useState([]);
  const [otherReasonStatus, setOtherReasonStatus] = useState(false);
  const [customReason, setCustomReason] = useState("");

  const [reportList, setReportList] = useState([]);
  const [selectedReason, setSelectedReason] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [reportEmail, setReportEmail] = useState("");
  const [reportDesc, setReportDesc] = useState("");
  const [files, setFiles] = useState(null);
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [isOnline, setIsOnline] = useState(false);
  const [emailError, setEmailError] = useState("");

  const [userInfo, setUserInfo] = useState({
    nickname: "",
    profileName: "",
    profilePic: "",
    profileImageLink: "",
    firstLetter: "",
    userId: "",
    emailStatus: false,
    mobileStatus: false,
    addressStatus: false,
    kycStatus: false,
    followStatus: false,
    blockStatus: false,
  });

  useEffect(() => {
    getUserTransactionBalanceRest();
    getAllAdsbuyUser();
    getAllAdsSellUser();
    fetchUserInfo();
    getAllPaymentMethodByUser();
    getAllBlockReason();
    getReportList();
  }, [uuid]);

  useEffect(() => {
    var foundValue = onlineUsers.filter(
      (obj) => decryptMessages(obj.userId) === userInfo?.userId?.toString()
    );
    if (foundValue.length > 0) {
      setIsOnline(true);
    } else {
      setIsOnline(false);
    }
  }, [onlineUsers]);
  console.log("onlineUsers", onlineUsers, isOnline);

  const fetchUserInfo = async () => {
    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
      usersUuid: decryptMessages(uuid),
    };

    try {
      const res = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/getP2PUserDetailsForOther`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const details = res.data.userDetails[0];
      setUserDetails(details);

      const nameToUse = details.nickName || details.name;
      const imageLink = details.profilePic
        ? `https://userkycdoc.s3.us-west-1.amazonaws.com/user_id_${details.userId}/${details.profilePic}`
        : "";

      const feedbackPercent =
        details.negativeFeedback === 0 && details.positiveFeedback > 0
          ? 100
          : details.negativeFeedback === 0 && details.positiveFeedback === 0
          ? 0
          : (details.positiveFeedback * 100) /
            (details.positiveFeedback + details.negativeFeedback);

      setPoitiveFeedPercent(feedbackPercent);
      setUserInfo({
        nickname: nameToUse,
        profileName: details.profileName,
        profilePic: details.profilePic,
        profileImageLink: imageLink,
        firstLetter: nameToUse.charAt(0),
        userId: details.userId,
        emailStatus: !!details.emailId,
        mobileStatus: !!details.mobileNo,
        addressStatus: !!details.usersAddress,
        kycStatus:
          details.bankDetailsStatus === 2 && details.userDocsStatus === 1,
        followStatus: details.followingStatus !== 0,
        blockStatus: details.blockedStatus !== 0,
      });
    } catch (error) {
      console.error("Error fetching user info", error);
    } finally {
      setLoading(false);
    }
  };

  const getUserTransactionBalanceRest = async () => {
    try {
      const userTransObj = {
        customerId: localStorage.getItem("user_id"),
        uuid: localStorage.getItem("uuid"),
      };

      const response = await axios.post(
        `${P2PWEBSERVICE}/transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const usdEntry = response.data.userBalanceList.find(
        (entry) => entry.currencyCode === "USDT"
      );
      setHoldingInUsd(usdEntry ? usdEntry.holdingInUsd : null);
    } catch (error) {
      console.error("Error fetching user balance:", error);
    }
  };

  const getAllPaymentMethodByUser = async () => {
    try {
      const uuid = localStorage.getItem("uuid");
      const accessToken = localStorage.getItem("access_token");

      const response = await axios.post(
        `${P2PWEBSERVICE}/getAllPaymentMethodByUser`,
        { uuid },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const { error, error_msg, paymentDetails } = response.data;

      if (error?.error_data === 0 && Array.isArray(paymentDetails)) {
        const bankMethods = [];
        const walletMethods = [];

        paymentDetails.forEach((method) => {
          if (method.paymentMethodName === "BANK TRANSFER") {
            let identificationType = "";
            let identificationNumber = "";

            if (method.ifscCode) {
              identificationType = "IFSC CODE";
              identificationNumber = method.ifscCode;
            } else if (method.swiftCode) {
              identificationType = "SWIFT CODE";
              identificationNumber = method.swiftCode;
            } else if (method.routingNo) {
              identificationType = "ROUTING NO";
              identificationNumber = method.routingNo;
            }

            bankMethods.push({
              accountHolderName: method.profileName,
              bankName: method.bankName,
              pmDetailsId: method.pmDetailsId,
              accountNo: method.accountNo,
              accountType: method.accountType,
              identificationType,
              identificationNumber,
              bankAddress: method.bankAddress,
            });
          } else {
            walletMethods.push({
              paymentProviderName: method.paymentProviderName,
              walletId: method.vpa,
              pmDetailsId: method.pmDetailsId,
              email_id: method.emailId,
              phone_number: method.mobileNo,
              profileName: method.profileName,
            });
          }
        });

        console.log(
          "BankTransferPaymentMethodList",
          bankTransferPaymentMethodList
        );
        console.log(
          "walletTransferPaymentMethodList",
          walletServicePaymentMethodList
        );

        setBankTransferPaymentMethodList(bankMethods);
        setWalletServicePaymentMethodList(walletMethods);
      } else {
        showToast("error", error_msg || "Failed to fetch payment methods");
        setBankTransferPaymentMethodList([]);
        setWalletServicePaymentMethodList([]);
      }
    } catch (error) {
      showToast("error", "Something went wrong while fetching payment methods");
      setBankTransferPaymentMethodList([]);
      setWalletServicePaymentMethodList([]);
    }
  };

  const getAllAdsbuyUser = async () => {
    try {
      const jsonObj = {
        uuid: decryptMessages(uuid),
        crypto: "",
        adType: "SELL",
        toDate: "",
        formDate: "",
        status: 2,
        fiat: "",
      };

      const response = await axios.post(
        "https://accounts.paybito.com/api/crypto/banking/p2p/getPostAdsByUser",
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      setAllBuyAds(response.data.postAdMyAdResponse ?? []);
    } catch (error) {
      console.error("Error fetching buy ads:", error);
    }
  };

  const getAllAdsSellUser = async () => {
    try {
      const jsonObj = {
        uuid: decryptMessages(uuid),
        crypto: "",
        adType: "BUY",
        toDate: "",
        formDate: "",
        status: 2,
        fiat: "",
      };

      const response = await axios.post(
        "https://accounts.paybito.com/api/crypto/banking/p2p/getPostAdsByUser",
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      setAllSellAds(response.data.postAdMyAdResponse ?? []);
    } catch (error) {
      console.error("Error fetching sell ads:", error);
    }
  };

  const buySellCrypto = (data, flag) => {
    console.log("data", data);

    reset();
    getOrderCount(data);

    setPaymentTimeLimit(data.paymentTimeLimit);
    setMinOrderLimit(data.minOrderLimit);
    setMaxOrderLimit(data.maxOrderLimit);
    setRemarks(data.remarks);
    // setPrice(data.priceType === "Floating" ? data.floatingPrice : data.price);
    setPrice(data.price);
    setFiat(data.fiat);
    setCrypto(data.crypto);
    setPaymentProviderName(data.paymentProviderNames || []);
    setAvailableAmount(data.remainingAmount);
    setProfileName(data.nickName);
    setAdId(data.adId);
    setCounterPartyUuid(data.uuid);
    setOrderId(data.pmDetailsId);
    setSellAmount(data.amount);
    setOnlineStatus(data.isOnline);
    setProfilePic(data.profilePic);
    setProfileImageLink(data.profileImageLink);
    setFirstLetter(data.firstLetter);
    setCurrentSelectedBankPaymentMethod([]);
    setSelectedBankPaymentMethod([]);
    setCurrentSelectedWalletPaymentMethod([]);
    setSelectedWalletPaymentMethod([]);
    setModalPrice(data.price);
    setModalRemainingAmount(data.remainingAmount);

    setSelectedWalletPaymentMethod([]);

    if (flag === "BUY") {
      setBuyDialogOpen(true);
    } else {
      setSellDialogOpen(true);
    }

    getP2PBalance();
  };

  const getAllRegion = async () => {
    try {
      const response = await axios.get(
        WEBSERVICE + `crypto/banking/p2p/getAllRegions`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      let regions = response.data.regions || [];

      setRegionList(regions);
    } catch (error) {
      console.error("Error fetching currency data:", error);
    }
  };

  const getOrderCount = async (data) => {
    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/getOrderCount`,
        JSON.stringify({ adId: Number(data.id) }),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      if (response.data) {
        setRecordCount(response.data.recordCount);
        setCompletionRate(Number(response.data.completionRate).toFixed(2));
      }
    } catch (error) {
      console.error("Error fetching order count:", error);
    }
  };

  const reset = () => {
    setPaymentTimeLimit(null);
    setMinOrderLimit(null);
    setMaxOrderLimit(null);
    setRemarks("");
    setPrice(null);
    setFiat("");
    setCrypto("");
    setPaymentProviderName([]);
    setAvailableAmount(null);
    setProfileName("");
    setAdId(null);
    setCounterPartyUuid("");
    setOrderId(null);
    setSellAmount(null);
    setOnlineStatus(null);
    setProfilePic("");
    setProfileImageLink("");
    setFirstLetter("");
    setCurrentSelectedBankPaymentMethod([]);
    setSelectedBankPaymentMethod([]);
    setCurrentSelectedWalletPaymentMethod([]);
    setSelectedWalletPaymentMethod([]);
  };

  const getP2PBalance = async () => {
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");

    const payload = {
      uuid,
      assets: crypto,
    };

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/getP2PBalance`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const apiMessage = response.data.error;
      if (apiMessage == null) {
        const walletDetails = response.data.p2pWalletDetails;
        if (walletDetails && walletDetails.length > 0) {
          setWalletAvailableBalance(walletDetails[0].amount);
        } else {
          setWalletAvailableBalance(0);
        }
      } else {
        // Replace this with your toast or alert method
        console.error("API Error:", apiMessage);
      }
    } catch (error) {
      console.error("Request Failed:", error);
    }
  };

  const handleBuyDialogClose = () => {
    setBuyDialogOpen(false);
  };

  const handleSellDialogClose = () => {
    setSellDialogOpen(false);
  };
  const handlePaymentEditDialogClose = () => {
    setPaymentEditModal(false);
  };

  function calculateTotalAmount(e) {
    setPayAmount(e);
    setReceiveAmount(e / parseFloat(price));

    // checkMinMax(e)
  }

  const addBankPaymentMethod = (i) => {
    const existingIndex = currentSelectedBankPaymentMethod.findIndex(
      (item) => item.currentIndex === i
    );
    const bankDetails = bankTransferPaymentMethodList[i];

    console.log("bankDetails", bankDetails);

    if (existingIndex !== -1) {
      // Deselect
      setCurrentSelectedBankPaymentMethod((prev) =>
        prev.filter((item) => item.currentIndex !== i)
      );
      setSelectedBankPaymentMethod((prev) =>
        prev.filter((item) => item.pmDetailsId !== bankDetails.pmDetailsId)
      );
    } else {
      // Select
      setCurrentSelectedBankPaymentMethod((prev) => [
        ...prev,
        { currentIndex: i },
      ]);
      setSelectedBankPaymentMethod((prev) => [
        ...prev,
        {
          pmDetailsId: bankDetails.pmDetailsId,
          bankName: bankDetails.bankName,
        },
      ]);
    }
  };

  const addWalletPaymentMethod = (i) => {
    const existingIndex = currentSelectedWalletPaymentMethod.findIndex(
      (item) => item.currentIndex === i
    );
    const walletDetails = walletServicePaymentMethodList[i];

    if (existingIndex !== -1) {
      // Deselect
      setCurrentSelectedWalletPaymentMethod((prev) =>
        prev.filter((item) => item.currentIndex !== i)
      );
      setSelectedWalletPaymentMethod((prev) =>
        prev.filter((item) => item.pmDetailsId !== walletDetails.pmDetailsId)
      );
    } else {
      // Select
      setCurrentSelectedWalletPaymentMethod((prev) => [
        ...prev,
        { currentIndex: i },
      ]);
      setSelectedWalletPaymentMethod((prev) => [
        ...prev,
        {
          pmDetailsId: walletDetails.pmDetailsId,
          paymentProviderName: walletDetails.paymentProviderName,
        },
      ]);
    }
  };

  const handleBuySellSubmit = async (type) => {
    if (payAmount === "" || receiveAmount === "") {
      showToast("error", "Please enter some amount !!!");
      return;
    }
    var inputObj = {
      adType: type,
      crypto: crypto,
      fiat: fiat,
      amount: receiveAmount,
      totalAmount: availableAmount,
      paymentTimeLimit: paymentTimeLimit,
      uuid: localStorage.getItem("uuid"),
      counterPartyUuid: decryptMessages(uuid),
      confirm: 0,
      adId: adId,
      advertiserProfileName: userInfo.nickname,
      userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    if (type === "BUY") {
      inputObj = inputObj;
      inputObj.price = price;
    } else {
      if (
        selectedWalletPaymentMethod.length === 0 &&
        selectedBankPaymentMethod.length === 0
      ) {
        showToast("error", "Please choose at least one payment method");
        return;
      }

      const allSelectedPaymentMethod = [
        ...selectedBankPaymentMethod.map((item) => item.bankName),
        ...selectedWalletPaymentMethod.map((item) => item.paymentProviderName),
      ];

      inputObj.pmList = allSelectedPaymentMethod;
      inputObj.pmList = allSelectedPaymentMethod;
      inputObj.price = price;
    }

    console.log("inputObj", inputObj);

    try {
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/buySellOfferCreate`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const data = response.data;

      if (data.errorResponse.error_data === 0) {
        localStorage.setItem("previousAdId", adId);
        localStorage.setItem("previousOrderId", data.orderId);
        localStorage.setItem("orderCreationTime", data.createdDate);
        localStorage.setItem("counterPartyUuid", decryptMessages(uuid));
        localStorage.setItem("chatUserName", profileName);
        localStorage.setItem("orderfiat", fiat);
        localStorage.setItem("orderCrypto", crypto);
        localStorage.setItem("profilePic", profilePic);
        localStorage.setItem("profileImageLink", profileImageLink);
        localStorage.setItem("firstLetter", firstLetter);

        if (type === "BUY") {
          localStorage.setItem("previousPageBuyAmount", price);
          localStorage.setItem("previousPageBuyTotalAmount", payAmount);
          localStorage.setItem("previousPageBuyprice", receiveAmount);
          handleBuyDialogClose(false); // close modal
        } else {
          localStorage.setItem("previousPageBuyAmount", price);

          localStorage.setItem("previousPageBuyTotalAmount", payAmount);
          localStorage.setItem("previousPageBuyprice", receiveAmount);
        }

        if (type === "BUY") {
          navigate("/p2p/order-details");
          // showToast('error', 'Buy successfull')
        } else {
          navigate("/p2p/sell-order-details");

          // navigate('/p2p/seller-order-created-details');
        }
      } else {
        showToast("error", data.errorResponse.error_msg);
      }
    } catch (error) {
      showToast("error", "Something went wrong while creating order.");
      console.error(error);
    }
  };

  const handleOpenEditPaymentModal = (pmDetailsId, index, service) => {
    if (service === "wallet_services") {
      setAccountHolderNameEdit(
        walletServicePaymentMethodList[index].profileName
      );
      setPaymentProviderNameEdit(
        walletServicePaymentMethodList[index].paymentProviderName
      );
      setPhoneNumberEdit(walletServicePaymentMethodList[index].phone_number);
      setWalletIdEdit(walletServicePaymentMethodList[index].walletId);
      setEmailIdEdit(walletServicePaymentMethodList[index].email_id);
      setEditPaymentMethod("Wallet Services");
    } else {
      setAccountHolderNameEdit(
        bankTransferPaymentMethodList[index].accountHolderName
      );
      setAccountNumberEdit(bankTransferPaymentMethodList[index].accountNo);
      setAccountTypeEdit(bankTransferPaymentMethodList[index].accountType);
      setIdentificationTypeEdit(
        bankTransferPaymentMethodList[index].identificationType
      );
      setRoutingNumberEdit(
        bankTransferPaymentMethodList[index].identificationNumber
      );
      setBankNameEdit(bankTransferPaymentMethodList[index].bankName);
      setBankAddressEdit(bankTransferPaymentMethodList[index].bankAddress);

      setValue(
        "accountHolder",
        bankTransferPaymentMethodList[index].accountHolderName || ""
      );
      setValue(
        "ibanNumber",
        bankTransferPaymentMethodList[index].accountNo || ""
      );

      setValue("bankName", bankTransferPaymentMethodList[index].bankName || "");
      setValue(
        "accountType",
        bankTransferPaymentMethodList[index].accountType || "Personal Savings"
      );
      setSelectedAccountType(bankTransferPaymentMethodList[index].accountType);
      setValue(
        "bankAddress",
        bankTransferPaymentMethodList[index].bankAddress || ""
      );

      setValue(
        "codeType",
        bankTransferPaymentMethodList[index].identificationType
      );
      setSelectedCodeType(
        bankTransferPaymentMethodList[index].identificationType
      );
      setValue(
        "additionalCode",
        bankTransferPaymentMethodList[index].identificationNumber
      );
      console.log(
        "additionalCode",
        bankTransferPaymentMethodList[index].identificationNumber
      );

      setEditPaymentMethod("Bank Transfer");
    }

    setPmDetailsId(pmDetailsId);
    setPaymentEditModal(true); // Show the modal
  };

  const validateBankCode = (code) => {
    if (!code) return "Required";
    const type = watch("codeType");
    let reg;
    if (type === "ROUTING NO") {
      reg = /^\d{9}$/gm;
      return reg.test(code)
        ? true
        : "Invalid Routing Number (9 digits required)";
    } else if (type === "SWIFT CODE") {
      reg = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/gm;
      return reg.test(code) ? true : "Invalid SWIFT Code";
    } else if (type === "IFSC CODE") {
      reg = /^[A-Z]{4}0[A-Z0-9]{6}$/gm;
      return reg.test(code) ? true : "Invalid IFSC Code";
    }
    return "Invalid Code";
  };

  // const handleFormSubmit = () => {
  //   setSubmitted(true);
  //   if (editPaymentMethod === 'Wallet Services') {
  //     if (
  //       formValues.payment_provider_name &&
  //       formValues.phone_number?.match(/^\d{8,15}$/) &&
  //       formValues.wallet_id &&
  //       formValues.email_id?.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/)
  //     ) {
  //       onSubmit(formValues);
  //     }
  //   } else {
  //     if (
  //       formValues.account_number &&
  //       formValues.account_type &&
  //       formValues.routing_number
  //     ) {
  //       onSubmit(formValues);
  //     }
  //   }
  // };

  // function checkMinMax(e) {
  //   if (e < minOrderLimit || e > maxOrderLimit) {
  //     this.minMaxCheckStatusErroe = true;
  //   }
  //   else {
  //     this.minMaxCheckStatusErroe = false;

  //   }
  // }

  const updateBankDetails = async () => {
    const formValues = watch();
    console.log("formValues.accountType", formValues);

    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    const payload = {
      uuid,
      action: "UPDATE",
      transferType: 2,
      paymentMethodName: "BANK TRANSFER",
      profileName: formValues.accountHolder,
      accountNo: formValues.ibanNumber,
      accountType: formValues.accountType,
      bankName: formValues.bankName,
      bankAddress: formValues.bankAddress,
      pmDetailsId: pmDetailsId,
    };

    switch (formValues.codeType) {
      case "ROUTING NO":
        payload.routingNo = formValues.additionalCode;
        break;
      case "IFSC CODE":
        payload.ifscCode = formValues.additionalCode;
        break;
      case "SWIFT CODE":
        payload.swiftCode = formValues.additionalCode;
        break;
      default:
        break;
    }
    // console.log('payload',payload);

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/updateAndDeletePaymentMethod`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const { error_data, error_msg } = response.data;

      if (error_data === 0) {
        showToast("success", "Payment Method updated successfully");

        setTimeout(() => {
          // Close modal and reset state
          setPaymentEditModal(false);
          setPmDetailsId("");
          setAccountHolderNameEdit("");
          setAccountNumberEdit("");
          setAccountTypeEdit("");
          setIdentificationTypeEdit("");
          setRoutingNumberEdit("");
          setBankNameEdit("");
          setBankAddressEdit("");

          getAllPaymentMethodByUser(); // Refresh list
        }, 2000);
      } else {
        showToast("error", error_msg);
      }
    } catch (error) {
      showToast("error", "An error occurred while updating the payment method");
      console.error("Update error:", error);
    }
  };

  const updateWalletDetails = async () => {
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    const payload = {
      uuid,
      action: "UPDATE",
      transferType: 1,
      paymentMethodName: "WALLET SERVICE",
      profileName: accountHolderNameEdit,
      mobileNo: phoneNumberEdit,
      vpa: walletIdEdit,
      emailId: emailIdEdit,
      paymentProviderName: paymentProviderNameEdit,
      pmDetailsId: pmDetailsId,
    };

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/updateAndDeletePaymentMethod`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const { error_data, error_msg } = response.data;

      if (error_data === 0) {
        showToast("success", "Payment Method updated successfully");

        setTimeout(() => {
          // Close modal and reset form
          setPaymentEditModal(false); // assumes you're using state to control modal visibility
          setPmDetailsId("");
          setPaymentProviderNameEdit("");
          setPhoneNumberEdit("");
          setWalletIdEdit("");
          setEmailIdEdit("");
          setAccountHolderNameEdit("");

          getAllPaymentMethodByUser(); // Refresh list
        }, 2000);
      } else {
        showToast("error", error_msg);
      }
    } catch (error) {
      showToast("error", "Failed to update payment method");
      console.error("Error updating wallet details:", error);
    }
  };

  function calculateAmount(e) {
    setReceiveAmount(e);
    setPayAmount(parseFloat(price) * parseFloat(e));
  }

  const followUnfollowUsers = async (e) => {
    const jsonObj = {
      followingUuid: decryptMessages(uuid),
      followerUuid: localStorage.getItem("uuid"),
      followingStatus: e,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/addFollowers`,
        jsonObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        showToast("success", response.data.error.error_msg);

        fetchUserInfo();
      } else {
        showToast("error", response.data.error.error_msg);
        fetchUserInfo();
      }
    } catch (error) {
      showToast("error", "Something went wrong. Please try again.");
      console.error(error);
    }
  };

  const blockUnblockFuncCall = async (status) => {
    if (status == 0) {
      setBlockModalOpen(true);
    } else {
      blockUnblockApiCall(0, 0);
    }
  };

  const blockUnblockApiCall = async (blockStatus, reasonId) => {
    const jsonObj = {
      blockBy: localStorage.getItem("uuid"),
      blockedUser: decryptMessages(uuid),
      blockStatus: blockStatus,
      reasonId: reasonId,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/blockP2PUser`,
        jsonObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        showToast(
          "successs",
          `${!userInfo.blockStatus ? "Block" : "Unblock"} Successfully`
        );
        setBlockModalOpen(false);
        fetchUserInfo();
      } else {
        showToast("error", response.data.error.error_msg);
        fetchUserInfo();
      }
    } catch (error) {
      showToast("error", "Something went wrong while unblocking");
      console.error(error);
    }
  };

  const getAllBlockReason = async () => {
    try {
      const res = await axios.get(
        `${WEBSERVICE}crypto/banking/p2p/getBlockReasons`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      setAllBlockReason(res.data.blockDetails);
    } catch (err) {
      showToast("error", "Failed to fetch block reasons");
    }
  };

  const getReportList = async () => {
    try {
      const res = await axios.get(
        `${WEBSERVICE}crypto/banking/p2p/getReportReasons`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      setReportList(res.data.reportDetails);
    } catch (err) {
      showToast("error", "Failed to fetch report reasons");
    }
  };

  const reportFileUpload = async () => {
    if (!selectedReason || !orderNumber || !reportEmail || !reportDesc) {
      showToast("error", "Cannot set blank when reporting");
      return;
    }

    const fileInput = document.getElementById("reportUploadFile");
    const selectedFile = fileInput?.files?.[0];

    const formData = new FormData();
    formData.append("uuid", localStorage.getItem("uuid"));
    formData.append("reasonId", selectedReason);
    formData.append("orderNo", orderNumber);
    formData.append("email", reportEmail);
    formData.append("description", reportDesc);
    if (files) {
      formData.append("proof", files);
    }

    try {
      const response = await axios.post(
        `${WEBSERVICE}crypto/banking/p2p/reportUser`,
        formData,
        {
          headers: {
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const res = response.data;
      if (res.error?.error_data === 0) {
        showToast("success", res.error.error_msg);
        setReportModalOpen(false); // If using modal state
      } else {
        showToast("error", res.error.error_msg);
        setReportModalOpen(false);
      }
    } catch (error) {
      showToast("error", "Something went wrong while reporting.");
      console.error(error);
    }
  };
  const onlyNumber = (e) => {
    const regex = /^[0-9]*$/; // Allow empty string and numbers only
    const value = e.target.value;

    // If the input doesn't match regex, prevent the change
    if (!regex.test(value)) {
      e.target.value = value.slice(0, -1); // Remove the last invalid character
      return;
    }

    // Update state only if valid
    setOrderNumber(value);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      return "Email is required";
    }

    if (!emailRegex.test(email)) {
      return "Please enter a valid email address";
    }

    return "";
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setReportEmail(value);

    // Real-time validation
    const error = validateEmail(value);
    setEmailError(error);
  };

  return (
    <>
      <P2PNavbar />
      <Box sx={pageWrapper}>
        {/* Hero Banner */}
        <Box
          sx={{
            ...heroBanner,
            background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
          }}
        >
          <Box sx={heroContent}>
            <Box sx={heroIconBadge}>
              <AccountCircleOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
            </Box>
            <Box>
              <Typography sx={heroTitle}>
                {userInfo.nickname || "User Profile"}
              </Typography>
              <Typography sx={heroSubtitle}>P2P Trader Profile</Typography>
            </Box>
          </Box>
        </Box>

        {/* Profile Header Card */}
        <Box sx={mainCard}>
          <Box
            sx={{
              p: { xs: 2, md: 3 },
              borderBottom: "1px solid rgba(125,125,125,0.12)",
            }}
          >
            <Stack direction="row" spacing={2} alignItems="center">
              <Box position="relative" display="inline-block">
                <Avatar
                  src={userInfo.profileImageLink}
                  sx={{ width: 60, height: 60 }}
                  alt={userInfo.firstLetter || "U"}
                />
                <CircleIcon
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    right: 3,
                    fontSize: 16,
                    color: isOnline ? green[500] : grey[500],
                  }}
                />
              </Box>
              <Box>
                <Typography
                  variant="h6"
                  sx={{ color: "var(--text-color)", fontWeight: 700 }}
                >
                  {userInfo.nickname}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "var(--text-color)", opacity: 0.6 }}
                >
                  {isOnline ? "Online" : "Offline"} | Joined on{" "}
                  {userDetails?.createdOn.split(" ")[0]}
                </Typography>
                <Stack direction="row" spacing={1} mt={1} flexWrap="wrap" useFlexGap>
                  <Chip
                    label={userInfo.followStatus ? "Unfollow" : "+Follow"}
                    onClick={() =>
                      followUnfollowUsers(userInfo.followStatus ? 0 : 1)
                    }
                    size="small"
                    sx={{
                      backgroundColor: alpha(btncolor || "#1976d2", 0.15),
                      color: btncolor,
                      border: "1px solid " + alpha(btncolor || "#1976d2", 0.3),
                      borderRadius: "6px",
                      fontWeight: 600,
                      fontSize: "0.78rem",
                    }}
                  />
                  <Chip
                    label={!userInfo.blockStatus ? "Block" : "Unblock"}
                    onClick={() =>
                      blockUnblockFuncCall(userInfo.blockStatus ? 1 : 0)
                    }
                    size="small"
                    sx={{
                      backgroundColor: "rgba(239,68,68,0.1)",
                      color: "#ef4444",
                      border: "1px solid rgba(239,68,68,0.3)",
                      borderRadius: "6px",
                      fontWeight: 600,
                      fontSize: "0.78rem",
                    }}
                  />
                  <Chip
                    label="REPORT"
                    size="small"
                    onClick={() => setReportModalOpen(true)}
                    sx={{
                      backgroundColor: "rgba(125,125,125,0.1)",
                      color: "var(--text-color)",
                      border: "1px solid rgba(125,125,125,0.3)",
                      borderRadius: "6px",
                      fontWeight: 600,
                      fontSize: "0.78rem",
                    }}
                  />
                </Stack>
              </Box>
            </Stack>

            {/* Verification Pills */}
            <Stack direction="row" spacing={1} mt={2} mb={1} flexWrap="wrap" useFlexGap>
              {[
                ["Email", userInfo.emailStatus],
                ["SMS", userInfo.mobileStatus],
                ["KYC", userInfo.kycStatus],
                ["Address", userInfo.addressStatus],
              ].map(([label, status]) => (
                <Box
                  key={label}
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.5,
                    px: 1.5,
                    py: 0.5,
                    borderRadius: "20px",
                    backgroundColor: status
                      ? "rgba(34,197,94,0.1)"
                      : "rgba(239,68,68,0.1)",
                    border: `1px solid ${
                      status ? "rgba(34,197,94,0.3)" : "rgba(239,68,68,0.3)"
                    }`,
                  }}
                >
                  {status ? (
                    <CheckCircleIcon sx={{ fontSize: 14, color: "#22c55e" }} />
                  ) : (
                    <CancelIcon sx={{ fontSize: 14, color: "#ef4444" }} />
                  )}
                  <Typography
                    sx={{
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      color: status ? "#22c55e" : "#ef4444",
                    }}
                  >
                    {label}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Box>

          {/* Metrics Grid */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr 1fr",
                sm: "repeat(3, 1fr)",
                md: "repeat(4, 1fr)",
                lg: "repeat(5, 1fr)",
              },
              gap: 2,
              p: { xs: 2, md: 3 },
            }}
          >
            <Box
              sx={{
                p: 2,
                backgroundColor: "var(--body-color-less2)",
                borderRadius: "12px",
                border: "1px solid rgba(125,125,125,0.12)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "var(--text-color)",
                  opacity: 0.55,
                  mb: 0.75,
                }}
              >
                30d Trades
              </Typography>
              <Typography
                sx={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-color)" }}
              >
                {userDetails?.trades30D} Time(s)
              </Typography>
            </Box>

            <Box
              sx={{
                p: 2,
                backgroundColor: "var(--body-color-less2)",
                borderRadius: "12px",
                border: "1px solid rgba(125,125,125,0.12)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "var(--text-color)",
                  opacity: 0.55,
                  mb: 0.75,
                }}
              >
                30d Completion Rate
              </Typography>
              <Typography
                sx={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-color)" }}
              >
                {userDetails?.completionRates30D}
              </Typography>
            </Box>

            <Box
              sx={{
                p: 2,
                backgroundColor: "var(--body-color-less2)",
                borderRadius: "12px",
                border: "1px solid rgba(125,125,125,0.12)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "var(--text-color)",
                  opacity: 0.55,
                  mb: 0.75,
                }}
              >
                Avg Release Time
              </Typography>
              <Typography
                sx={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-color)" }}
              >
                {userDetails?.avgReleaseTime}
              </Typography>
            </Box>

            <Box
              sx={{
                p: 2,
                backgroundColor: "var(--body-color-less2)",
                borderRadius: "12px",
                border: "1px solid rgba(125,125,125,0.12)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "var(--text-color)",
                  opacity: 0.55,
                  mb: 0.75,
                }}
              >
                Avg Pay Time
              </Typography>
              <Typography
                sx={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-color)" }}
              >
                {userDetails?.avgPayTime}
              </Typography>
            </Box>

            <Box
              sx={{
                p: 2,
                backgroundColor: "var(--body-color-less2)",
                borderRadius: "12px",
                border: "1px solid rgba(125,125,125,0.12)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "var(--text-color)",
                  opacity: 0.55,
                  mb: 0.75,
                }}
              >
                Positive Feedback
              </Typography>
              <Typography
                sx={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-color)" }}
              >
                {poitiveFeedPercent.toFixed(2)}% ({userDetails?.positiveFeedback})
              </Typography>
              <Typography sx={{ fontSize: "0.75rem", color: "#22c55e" }}>
                Positive: {userDetails?.positiveFeedback}
              </Typography>
              <Typography sx={{ fontSize: "0.75rem", color: "#ef4444" }}>
                Negative: {userDetails?.negativeFeedback}
              </Typography>
            </Box>

            <Box
              sx={{
                p: 2,
                backgroundColor: "var(--body-color-less2)",
                borderRadius: "12px",
                border: "1px solid rgba(125,125,125,0.12)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "var(--text-color)",
                  opacity: 0.55,
                  mb: 0.75,
                }}
              >
                Registration Age
              </Typography>
              <Typography
                sx={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-color)" }}
              >
                {userDetails?.registrationAge} days ago
              </Typography>
            </Box>

            <Box
              sx={{
                p: 2,
                backgroundColor: "var(--body-color-less2)",
                borderRadius: "12px",
                border: "1px solid rgba(125,125,125,0.12)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "var(--text-color)",
                  opacity: 0.55,
                  mb: 0.75,
                }}
              >
                First Trade Age
              </Typography>
              <Typography
                sx={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-color)" }}
              >
                {userDetails?.firstTradeDate} days ago
              </Typography>
            </Box>

            <Box
              sx={{
                p: 2,
                backgroundColor: "var(--body-color-less2)",
                borderRadius: "12px",
                border: "1px solid rgba(125,125,125,0.12)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "var(--text-color)",
                  opacity: 0.55,
                  mb: 0.75,
                }}
              >
                30-day Trading Volume
              </Typography>
              <Typography
                sx={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-color)" }}
              >
                {userDetails?.tradingVolInUSD30D.toFixed(2)} USD
              </Typography>
            </Box>

            <Box
              sx={{
                p: 2,
                backgroundColor: "var(--body-color-less2)",
                borderRadius: "12px",
                border: "1px solid rgba(125,125,125,0.12)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "var(--text-color)",
                  opacity: 0.55,
                  mb: 0.75,
                }}
              >
                Total Trading Volume
              </Typography>
              <Typography
                sx={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-color)" }}
              >
                {userDetails?.tradingVolInUSD.toFixed(2)} USD
              </Typography>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 2, borderColor: "rgba(125,125,125,0.15)" }} />

        {/* Online Buy Ads Section */}
        <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-color)", mb: 2 }}>
          Online Buy Ads
        </Typography>
        <TableContainer sx={modernTableContainer}>
          <Table>
            <TableHead>
              <TableRow sx={tableHeadRow}>
                {["Coin", "Price", "Limit/Available", "Payment", "Action"].map(
                  (h) => (
                    <TableCell key={h} sx={tableHeadCell}>
                      {h}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {allBuyAds.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} sx={{ borderBottom: 0 }}>
                    <Box sx={{ py: 5, textAlign: "center" }}>
                      <InboxOutlinedIcon
                        sx={{
                          fontSize: 40,
                          color: "var(--text-color)",
                          opacity: 0.2,
                          mb: 1,
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: "0.88rem",
                          color: "var(--text-color)",
                          opacity: 0.5,
                        }}
                      >
                        No ads available
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                allBuyAds.map((ad, idx) => (
                  <TableRow key={idx} sx={tableBodyRow}>
                    <TableCell sx={tableBodyCell}>{ad.crypto}</TableCell>
                    <TableCell sx={tableBodyCell}>{ad.price}</TableCell>
                    <TableCell sx={tableBodyCell}>
                      <Typography
                        sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}
                      >
                        Available {ad.remainingAmount} {ad.crypto}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          color: "var(--text-color)",
                          opacity: 0.6,
                        }}
                      >
                        {ad.fiat}
                        {ad.minOrderLimit} - {ad.fiat}
                        {ad.maxOrderLimit}
                      </Typography>
                    </TableCell>
                    <TableCell sx={tableBodyCell}>
                      <Box display="flex" flexWrap="wrap" gap={0.75}>
                        {ad.paymentProviderNames.map((m, i) => (
                          <Box
                            key={i}
                            sx={{
                              px: 1,
                              py: 0.25,
                              borderRadius: "6px",
                              backgroundColor: alpha(
                                btncolor || "#1976d2",
                                0.1
                              ),
                              color: btncolor,
                              fontSize: "0.72rem",
                              fontWeight: 600,
                            }}
                          >
                            {m}
                          </Box>
                        ))}
                      </Box>
                    </TableCell>
                    <TableCell sx={tableBodyCell}>
                      <ContainedButton
                        variant="contained"
                        onClick={() => buySellCrypto(ad, "BUY")}
                        sx={{
                          borderRadius: "8px",
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.78rem",
                        }}
                      >
                        Buy {selectedFiatCurrency}
                      </ContainedButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Online Sell Ads Section */}
        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: 700,
            color: "var(--text-color)",
            mb: 2,
            mt: 4,
          }}
        >
          Online Sell Ads
        </Typography>
        <TableContainer sx={modernTableContainer}>
          <Table>
            <TableHead>
              <TableRow sx={tableHeadRow}>
                {["Coin", "Price", "Limit/Available", "Payment", "Action"].map(
                  (h) => (
                    <TableCell key={h} sx={tableHeadCell}>
                      {h}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {allSellAds.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} sx={{ borderBottom: 0 }}>
                    <Box sx={{ py: 5, textAlign: "center" }}>
                      <InboxOutlinedIcon
                        sx={{
                          fontSize: 40,
                          color: "var(--text-color)",
                          opacity: 0.2,
                          mb: 1,
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: "0.88rem",
                          color: "var(--text-color)",
                          opacity: 0.5,
                        }}
                      >
                        No ads available
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                allSellAds.map((ad, idx) => (
                  <TableRow key={idx} sx={tableBodyRow}>
                    <TableCell sx={tableBodyCell}>{ad.crypto}</TableCell>
                    <TableCell sx={tableBodyCell}>{ad.price}</TableCell>
                    <TableCell sx={tableBodyCell}>
                      <Typography
                        sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}
                      >
                        Available {ad.remainingAmount} {ad.crypto}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          color: "var(--text-color)",
                          opacity: 0.6,
                        }}
                      >
                        {ad.fiat}
                        {ad.minOrderLimit} - {ad.fiat}
                        {ad.maxOrderLimit}
                      </Typography>
                    </TableCell>
                    <TableCell sx={tableBodyCell}>
                      <Box display="flex" flexWrap="wrap" gap={0.75}>
                        {ad.paymentProviderNames.map((m, i) => (
                          <Box
                            key={i}
                            sx={{
                              px: 1,
                              py: 0.25,
                              borderRadius: "6px",
                              backgroundColor: alpha(
                                btncolor || "#1976d2",
                                0.1
                              ),
                              color: btncolor,
                              fontSize: "0.72rem",
                              fontWeight: 600,
                            }}
                          >
                            {m}
                          </Box>
                        ))}
                      </Box>
                    </TableCell>
                    <TableCell sx={tableBodyCell}>
                      <ContainedButton
                        variant="contained"
                        onClick={() => buySellCrypto(ad, "SELL")}
                        sx={{
                          borderRadius: "8px",
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.78rem",
                        }}
                      >
                        Sell {selectedFiatCurrency}
                      </ContainedButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Buy Dialog */}
      <ModalContent
        open={buyDialogOpen}
        onClose={handleBuyDialogClose}
        title={`BUY ${selectedFiatCurrency}`}
        width="md"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 3,
            flexWrap: "wrap",
            p: 1,
          }}
        >
          {/* Left Side - Seller Info */}
          <Box
            sx={{
              flex: "1 1 50%",
              backgroundColor: "var(--body-color-less2)",
              borderRadius: 2,
              p: 3,
              minWidth: 300,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar src="/avatar.png" alt="Seller" />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {profileName}
              </Typography>
            </Box>

            <Typography variant="body2" sx={{ mt: 1, color: "#aaa" }}>
              {recordCount} orders &nbsp; &nbsp; {completionRate}% Completion
            </Typography>

            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ color: "#aaa" }}>Price</Typography>
              <Typography sx={{ color: "#00e676", fontWeight: 600 }}>
                {price} {fiat}
              </Typography>
            </Box>

            <Box
              sx={{
                mt: 1,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ color: "#aaa" }}>Available</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {availableAmount} {crypto}
              </Typography>
            </Box>

            <Box
              sx={{
                mt: 1,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ color: "#aaa" }}>Payment Time Limit</Typography>
              <Typography>{paymentTimeLimit} Minutes</Typography>
            </Box>

            <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
              {paymentProviderName.map((m, i) => (
                <Chip
                  key={i}
                  label={m}
                  size="small"
                  sx={{ background: btncolor, color: "#fff" }}
                />
              ))}
            </Box>

            <Typography
              variant="caption"
              sx={{ mt: 2, fontStyle: "italic", color: "#888" }}
            >
              Advertiser's Terms (Please read carefully)
              <p>{remarks}</p>
            </Typography>
          </Box>

          {/* Right Side - Form */}
          <Box sx={{ flex: "1 1 45%", minWidth: 300 }}>
            <Typography sx={{ mb: 0.5 }}>I want to pay</Typography>
            <TextField
              fullWidth
              type="number"
              placeholder={`${minOrderLimit} - ${maxOrderLimit}`}
              value={payAmount}
              onChange={(e) => calculateTotalAmount(e.target.value)}
              error={payAmount < minOrderLimit || payAmount > maxOrderLimit}
              helperText={
                payAmount < minOrderLimit || payAmount > maxOrderLimit
                  ? `Amount must be between ${minOrderLimit} and ${maxOrderLimit}`
                  : ""
              }
              InputProps={{
                endAdornment: (
                  <Typography sx={{ ml: 1, color: "#aaa" }}>{fiat}</Typography>
                ),
              }}
              sx={{ mb: 2 }}
            />

            <Typography sx={{ mb: 0.5 }}>I will receive</Typography>
            <TextField
              fullWidth
              placeholder={crypto}
              value={receiveAmount}
              onChange={(e) => calculateAmount()}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <Typography sx={{ ml: 1, color: "#aaa" }}>
                    {crypto}
                  </Typography>
                ),
              }}
              sx={{ mb: 2 }}
            />
          </Box>
        </Box>
        <Box sx={{ px: 3, pb: 3, display: "flex", justifyContent: "flex-end" }}>
          <OutlinedButton
            onClick={() => handleBuyDialogClose()}
            variant="outlined"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              width: 120,
              mr: 2,
            }}
          >
            Cancel
          </OutlinedButton>
          <ContainedButton
            onClick={() => handleBuySellSubmit("BUY")}
            variant="contained"
            disabled={payAmount < minOrderLimit || payAmount > maxOrderLimit}
            sx={{
              fontWeight: "bold",
              textTransform: "none",
              borderRadius: 2,
              width: 140,
            }}
          >
            Buy {crypto}
          </ContainedButton>
        </Box>
      </ModalContent>

      {/* Sell Dialog */}
      <ModalContent
        open={sellDialogOpen}
        onClose={handleSellDialogClose}
        title={`Sell ${selectedFiatCurrency}`}
        width="md"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 3,
            flexWrap: "wrap",
            p: 1,
          }}
        >
          {/* Left Side - Seller Info */}
          <Box
            sx={{
              flex: "1 1 50%",
              backgroundColor: "var(--body-color-less2)",
              borderRadius: 2,
              p: 3,
              minWidth: 300,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar src="/avatar.png" alt="Seller" />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {profileName}
              </Typography>
            </Box>

            <Typography variant="body2" sx={{ mt: 1, color: "#aaa" }}>
              {recordCount} orders &nbsp; &nbsp; {completionRate}% Completion
            </Typography>

            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ color: "#aaa" }}>Price</Typography>
              <Typography sx={{ color: "#00e676", fontWeight: 600 }}>
                {price} {fiat}
              </Typography>
            </Box>

            <Box
              sx={{
                mt: 1,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ color: "#aaa" }}>Available</Typography>
              <Typography sx={{ fontWeight: 500 }}>
                {availableAmount} {crypto}
              </Typography>
            </Box>

            <Box
              sx={{
                mt: 1,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ color: "#aaa" }}>Payment Time Limit</Typography>
              <Typography>{paymentTimeLimit} Minutes</Typography>
            </Box>

            <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
              {paymentProviderName.map((m, i) => (
                <Chip
                  key={i}
                  label={m}
                  size="small"
                  sx={{ background: btncolor, color: "#fff" }}
                />
              ))}
            </Box>

            <Typography
              variant="caption"
              sx={{ mt: 2, fontStyle: "italic", color: "#888" }}
            >
              Advertiser's Terms (Please read carefully)
              <p>{remarks}</p>
            </Typography>
          </Box>

          {/* Right Side - Form */}
          <Box sx={{ flex: "1 1 45%", minWidth: 300 }}>
            <Typography sx={{ mb: 0.5 }}>I will receive</Typography>
            <TextField
              fullWidth
              type="number"
              placeholder={`${minOrderLimit} - ${maxOrderLimit}`}
              value={payAmount}
              onChange={(e) => calculateTotalAmount(e.target.value)}
              error={payAmount < minOrderLimit || payAmount > maxOrderLimit}
              helperText={
                payAmount < minOrderLimit || payAmount > maxOrderLimit
                  ? `Amount must be between ${minOrderLimit} and ${maxOrderLimit}`
                  : ""
              }
              InputProps={{
                endAdornment: (
                  <Typography sx={{ ml: 1, color: "#aaa" }}>{fiat}</Typography>
                ),
              }}
              sx={{ mb: 2 }}
            />

            <Typography sx={{ mb: 0.5 }}>I want to sell</Typography>
            <TextField
              fullWidth
              placeholder={crypto}
              value={receiveAmount}
              onChange={(e) => calculateAmount(e.target.value)}
              InputProps={{
                // readOnly: true,
                endAdornment: (
                  <Typography sx={{ ml: 1, color: "#aaa" }}>
                    {crypto}
                  </Typography>
                ),
              }}
              sx={{ mb: 2 }}
            />

            <Grid>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                  mt: 1,
                }}
              >
                <Typography>Available : 1245377</Typography>
                <ContainedButton>Add Fund</ContainedButton>
              </Box>
              <Box>
                <Box sx={modernTableContainer}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={tableHeadRow}>
                        <TableCell sx={tableHeadCell}>Account Holder's Name</TableCell>
                        <TableCell sx={tableHeadCell}>Bank Name</TableCell>
                        <TableCell sx={tableHeadCell}>Action</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {bankTransferPaymentMethodList.map((row, idx) => (
                        <TableRow key={idx} sx={tableBodyRow}>
                          <TableCell sx={tableBodyCell}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      onChange={() => addBankPaymentMethod(idx)}
                                    />
                                  }
                                  label={row.accountHolderName}
                                />
                              </FormGroup>
                            </Box>
                          </TableCell>
                          <TableCell sx={tableBodyCell}>{row.bankName}</TableCell>
                          <TableCell sx={tableBodyCell}>
                            <EditIcon
                              onClick={(e) =>
                                handleOpenEditPaymentModal(
                                  row.pmDetailsId,
                                  idx,
                                  "bank_transfer_services"
                                )
                              }
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>

                <Box sx={{ ...modernTableContainer, mt: 2 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={tableHeadRow}>
                        <TableCell sx={tableHeadCell}>Payment Provider Name</TableCell>
                        <TableCell sx={tableHeadCell}>Wallet Id</TableCell>
                        <TableCell sx={tableHeadCell}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {walletServicePaymentMethodList.map((row, idx) => (
                        <TableRow key={idx} sx={tableBodyRow}>
                          <TableCell sx={tableBodyCell}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      onChange={() =>
                                        addWalletPaymentMethod(idx)
                                      }
                                    />
                                  }
                                  label={row.paymentProviderName}
                                />
                              </FormGroup>
                            </Box>
                          </TableCell>
                          <TableCell sx={tableBodyCell}>{row.walletId}</TableCell>
                          <TableCell sx={tableBodyCell}>
                            <EditIcon
                              onClick={(e) =>
                                handleOpenEditPaymentModal(
                                  row.pmDetailsId,
                                  idx,
                                  "wallet_services"
                                )
                              }
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Box>
            </Grid>
          </Box>
        </Box>

        <Box sx={{ px: 3, pb: 3, display: "flex", justifyContent: "flex-end" }}>
          <OutlinedButton
            onClick={() => handleSellDialogClose()}
            variant="outlined"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              width: 120,
              mr: 2,
            }}
          >
            Cancel
          </OutlinedButton>
          <ContainedButton
            onClick={() => handleBuySellSubmit("SELL")}
            variant="contained"
            disabled={payAmount < minOrderLimit || payAmount > maxOrderLimit}
            sx={{
              fontWeight: "bold",
              textTransform: "none",
              borderRadius: 2,
              width: 140,
            }}
          >
            Sell {crypto}
          </ContainedButton>
        </Box>
      </ModalContent>

      {/* Payment Edit Dialog */}
      <Dialog
        open={paymentEditModal}
        onClose={() => handlePaymentEditDialogClose}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          {editPaymentMethod === "Wallet Services"
            ? "Update Wallet Payment Method"
            : "Update Bank Transfer Payment Method"}
          <IconButton
            onClick={() => setPaymentEditModal(false)}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={dialogContentStyle}>
          {editPaymentMethod === "Wallet Services" ? (
            <Grid container spacing={2} mt={1}>
              <Grid size={12}>
                <TextField
                  label="Payment Provider Name"
                  name="payment_provider_name"
                  value={paymentProviderNameEdit}
                  onChange={(e) => setPaymentProviderNameEdit(e.target.value)}
                  fullWidth
                  required
                  error={submitted && !formValues.payment_provider_name}
                  helperText={
                    submitted && !formValues.payment_provider_name
                      ? "Required"
                      : ""
                  }
                  sx={modernFieldStyle}
                />
              </Grid>

              <Grid size={4}>
                <TextField
                  label="Phone Number"
                  name="phone_number"
                  value={phoneNumberEdit}
                  onChange={(e) => setPhoneNumberEdit(e.target.value)}
                  fullWidth
                  required
                  error={
                    submitted && !formValues.phone_number?.match(/^\d{8,15}$/)
                  }
                  helperText={
                    submitted && !formValues.phone_number?.match(/^\d{8,15}$/)
                      ? "Enter a valid phone number"
                      : ""
                  }
                  sx={modernFieldStyle}
                />
              </Grid>

              <Grid size={4}>
                <TextField
                  label="Wallet ID"
                  name="wallet_id"
                  value={walletIdEdit}
                  onChange={(e) => setWalletIdEdit(e.target.value)}
                  fullWidth
                  required
                  error={submitted && !walletIdEdit}
                  helperText={submitted && !walletIdEdit ? "Required" : ""}
                  sx={modernFieldStyle}
                />
              </Grid>

              <Grid size={4}>
                <TextField
                  label="Email ID"
                  name="email_id"
                  value={emailIdEdit}
                  onChange={(e) => setEmailIdEdit(e.target.value)}
                  fullWidth
                  required
                  error={
                    submitted &&
                    !emailIdEdit?.match(
                      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
                    )
                  }
                  helperText={
                    submitted &&
                    !emailIdEdit?.match(
                      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
                    )
                      ? "Enter a valid email"
                      : ""
                  }
                  sx={modernFieldStyle}
                />
              </Grid>
            </Grid>
          ) : (
            <Box component="form" noValidate>
              <Grid container spacing={2} mt={1}>
                <Grid size={6}>
                  <TextField
                    label="Account Holder's Name"
                    fullWidth
                    {...register("accountHolder", {
                      required: "Required",
                      pattern: {
                        value: /^[A-Za-z\s]+$/,
                        message: "Only alphabets and spaces are allowed",
                      },
                      maxLength: {
                        value: 40,
                        message: "Maximum 40 characters allowed",
                      },
                    })}
                    error={!!errors.accountHolder}
                    helperText={errors.accountHolder?.message}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={6}>
                  <TextField
                    label="IBAN / Account Number"
                    fullWidth
                    {...register("ibanNumber", {
                      required: "Required",
                      pattern: {
                        value: /^[a-zA-Z0-9\s]+$/,
                        message: "Letters and numbers are allowed",
                      },
                      maxLength: {
                        value: 40,
                        message: "Maximum 40 characters allowed",
                      },
                    })}
                    error={!!errors.ibanNumber}
                    helperText={errors.ibanNumber?.message}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={6}>
                  <FormControl fullWidth>
                    <InputLabel>Account Type</InputLabel>
                    <Select
                      label="Account Type"
                      {...register("accountType", { required: "Required" })}
                      value={selectedAccountType}
                      onChange={(e) => setSelectedAccountType(e.target.value)}
                    >
                      <MenuItem value="Personal Savings">
                        Personal Savings
                      </MenuItem>
                      <MenuItem value="Personal Checking">
                        Personal Checking
                      </MenuItem>
                      <MenuItem value="Business Savings">
                        Business Savings
                      </MenuItem>
                      <MenuItem value="Business Checking">
                        Business Checking
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={3}>
                  <FormControl fullWidth>
                    <InputLabel>Code Type</InputLabel>
                    <Select
                      label="Code Type"
                      {...register("codeType", { required: "Required" })}
                      value={selectedCodeType}
                      onChange={(e) => setSelectedCodeType(e.target.value)}
                    >
                      <MenuItem value="ROUTING NO">ROUTING NO</MenuItem>
                      <MenuItem value="IFSC CODE">IFSC CODE</MenuItem>
                      <MenuItem value="SWIFT CODE">SWIFT CODE</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={3}>
                  <TextField
                    label="Enter Code"
                    fullWidth
                    {...register("additionalCode")}
                    error={!!errors.additionalCode}
                    helperText={errors.additionalCode?.message}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={6}>
                  <TextField
                    label="Bank Name"
                    fullWidth
                    {...register("bankName", {
                      required: "Required",
                      pattern: {
                        value: /^[a-zA-Z0-9\s]+$/,
                        message: "Letters and numbers are allowed",
                      },
                      maxLength: {
                        value: 50,
                        message: "Maximum 50 characters allowed",
                      },
                    })}
                    error={!!errors.bankName}
                    helperText={errors.bankName?.message}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={6}>
                  <TextField
                    label="Bank Address"
                    fullWidth
                    {...register("bankAddress", {
                      required: "Required",
                      pattern: {
                        value: /^[a-zA-Z0-9,\-\s\/]+$/,
                        message:
                          "Letters, numbers, commas, and hyphens are allowed",
                      },
                      maxLength: {
                        value: 200,
                        message: "Maximum 200 characters allowed",
                      },
                    })}
                    error={!!errors.bankAddress}
                    helperText={errors.bankAddress?.message}
                    sx={modernFieldStyle}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={dialogActionsStyle}>
          <ContainedButton onClick={() => setPaymentEditModal(false)}>
            Cancel
          </ContainedButton>

          {editPaymentMethod === "Wallet Services" ? (
            <OutlinedButton
              variant="contained"
              color="primary"
              onClick={() => updateWalletDetails()}
            >
              Submit
            </OutlinedButton>
          ) : (
            <OutlinedButton
              variant="contained"
              color="primary"
              onClick={() => updateBankDetails()}
            >
              Submit
            </OutlinedButton>
          )}
        </DialogActions>
      </Dialog>

      {/* Block Dialog */}
      <Dialog
        open={blockModalOpen}
        onClose={(e) => setBlockModalOpen(false)}
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Block
          <IconButton
            onClick={() => setBlockModalOpen(false)}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={dialogContentStyle}>
          <FormControl>
            <RadioGroup
              value={selectedReason}
              onChange={(e) => {
                setSelectedReason(e.target.value);
                setOtherReasonStatus(e.target.value === "other");
              }}
            >
              {allBlockReason.map((block) => (
                <FormControlLabel
                  key={block.id}
                  value={block.id.toString()}
                  control={<Radio />}
                  label={block.reason}
                  sx={{ color: "var(--text-color)" }}
                />
              ))}
            </RadioGroup>
          </FormControl>

          {otherReasonStatus && (
            <TextField
              multiline
              rows={3}
              fullWidth
              placeholder="Please tell us the reason for blocking the user"
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
              style={{ marginTop: 10 }}
              sx={modernFieldStyle}
            />
          )}
        </DialogContent>
        <DialogActions sx={dialogActionsStyle}>
          <OutlinedButton
            variant="contained"
            color="primary"
            onClick={(e) => blockUnblockApiCall(1, selectedReason)}
            style={{ marginTop: 16 }}
            disabled={!selectedReason}
          >
            Block
          </OutlinedButton>
        </DialogActions>
      </Dialog>

      {/* Report Dialog */}
      <Dialog
        open={reportModalOpen}
        onClose={() => setReportModalOpen(false)}
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Report
          <IconButton
            onClick={() => setReportModalOpen(false)}
            size="small"
            sx={dialogCloseBtn}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={dialogContentStyle}>
          <Box mt={1}>
            <TextField
              select
              label="Report Reason *"
              fullWidth
              value={selectedReason}
              onChange={(e) => setSelectedReason(e.target.value)}
              style={{ marginBottom: 12 }}
              sx={modernFieldStyle}
            >
              {reportList.map((r) => (
                <MenuItem key={r.id} value={r.id}>
                  {r.reason}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              label="Order Number *"
              fullWidth
              value={orderNumber}
              onChange={onlyNumber}
              style={{ marginBottom: 12 }}
              onKeyUp={onlyNumber}
              sx={modernFieldStyle}
            />

            <TextField
              label="Your Email *"
              fullWidth
              value={reportEmail}
              onChange={handleEmailChange}
              error={!!emailError}
              helperText={emailError}
              style={{ marginBottom: 12 }}
              sx={modernFieldStyle}
            />

            <TextField
              label="Description *"
              fullWidth
              multiline
              rows={3}
              value={reportDesc}
              onChange={(e) => setReportDesc(e.target.value)}
              style={{ marginBottom: 12 }}
              sx={modernFieldStyle}
            />

            <input
              type="file"
              multiple
              onChange={(e) => setFiles(e.target.files[0])}
              style={{ marginBottom: 12 }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={dialogActionsStyle}>
          <OutlinedButton
            variant="outlined"
            onClick={() => setReportModalOpen(false)}
          >
            Cancel
          </OutlinedButton>
          <OutlinedButton
            variant="contained"
            onClick={(e) => reportFileUpload()}
            disabled={
              !selectedReason ||
              !orderNumber.trim() ||
              !reportEmail.trim() ||
              !reportDesc.trim() ||
              emailError
            }
          >
            Report
          </OutlinedButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default P2PPublicProfile;

// ─── Design System Constants ────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  overflow: "hidden",
  mb: 3,
};

const modernTableContainer = {
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.15)",
  overflow: "hidden",
  backgroundColor: "var(--body-color-less)",
};

const tableHeadRow = {
  backgroundColor: "var(--body-color-less2)",
};

const tableHeadCell = {
  fontSize: "0.72rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.6,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  py: 1.75,
  px: 2,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  whiteSpace: "nowrap",
};

const tableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "rgba(125,125,125,0.04)" },
  "&:last-child td": { borderBottom: 0 },
};

const tableBodyCell = {
  py: 1.65,
  px: 2,
  fontSize: "0.85rem",
  color: "var(--text-color)",
  borderBottom: "1px solid rgba(125,125,125,0.08)",
};

const dialogPaper = {
  borderRadius: "16px",
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
  boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
};

const dialogTitleStyle = {
  textAlign: "center",
  fontWeight: 700,
  fontSize: "1.1rem",
  py: 2.25,
  color: "var(--text-color)",
  backgroundColor: "var(--popupheader-color)",
  position: "relative",
};

const dialogCloseBtn = {
  position: "absolute",
  right: 12,
  top: "50%",
  transform: "translateY(-50%)",
  color: "var(--text-color)",
  opacity: 0.6,
};

const dialogContentStyle = {
  pt: 2.5,
  pb: 2,
  px: { xs: 2.5, md: 3 },
  backgroundColor: "var(--popupbody-color)",
};

const dialogActionsStyle = {
  px: 3,
  py: 2,
  backgroundColor: "var(--popupbody-color)",
  justifyContent: "flex-end",
  gap: 1,
};

const modernFieldStyle = {
  "& .MuiInputBase-root": {
    height: "46px",
    borderRadius: "10px",
    backgroundColor: "var(--body-color-less2)",
    color: "var(--text-color)",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.25)",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(125,125,125,0.45)",
  },
  "& .MuiInputLabel-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiInputLabel-root.Mui-focused": { color: "var(--text-color)" },
};
